import { useCreation } from 'ahooks'
import {
  Breadcrumb as AntdBreadcrumb,
  type BreadcrumbProps as AntdBreadcrumbProps
} from 'antd'
import { createStyles } from 'antd-style'

import { useMatchedResources } from '../../hooks/useMatchedResources'
import { RouterLink } from '../Link'
import { useRouterStore } from '../Store/hooks/useStore'

import { BreadcrumbProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  breadcrumb: {
    paddingInline: token.padding
  }
}))

export const Breadcrumb = ({ className, style }: BreadcrumbProps) => {
  const allResources = useRouterStore(state => state.allResources)
  const matchedResources = useMatchedResources(allResources)
  const items: AntdBreadcrumbProps['items'] = useCreation(() => {
    const values: AntdBreadcrumbProps['items'] = []
    const lastIndex = matchedResources.length - 1
    for (let i = 0; i <= lastIndex; i++) {
      const { key, path, title } = matchedResources[i]
      if (i !== 0) {
        values.push({
          type: 'separator',
          separator: '/'
        })
      }
      values.push({
        key,
        title:
          path && i !== lastIndex ? (
            <RouterLink to={path} type='text'>
              {title}
            </RouterLink>
          ) : (
            title
          )
      })
    }
    return values
  }, [matchedResources])

  const { cx, styles } = useStyles()

  return (
    <AntdBreadcrumb
      className={cx(styles.breadcrumb, className)}
      items={items}
      separator=''
      style={style}
    />
  )
}
